import { createIcon } from '@chakra-ui/icons';

export const DeleteAlt = createIcon({
  displayName: 'DeleteAlt',
  viewBox: '0 0 22 24',
  d: 'M6.66667 0V1.33333H0V4H1.33333V21.3333C1.33333 22.0406 1.61428 22.7189 2.11438 23.219C2.61448 23.719 3.29276 24 4 24H17.3333C18.0406 24 18.7189 23.719 19.219 23.219C19.719 22.7189 20 22.0406 20 21.3333V4H21.3333V1.33333H14.6667V0H6.66667ZM6.66667 6.66667H9.33333V18.6667H6.66667V6.66667ZM12 6.66667H14.6667V18.6667H12V6.66667Z',
});
